import { render, staticRenderFns } from "./brows.vue?vue&type=template&id=95aac434&"
import script from "./brows.vue?vue&type=script&lang=js&"
export * from "./brows.vue?vue&type=script&lang=js&"
import style0 from "./brows.vue?vue&type=style&index=0&id=95aac434&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports